export default __webpack_public_path__ + "static/media/gallery - story - three brothers (1)_00.adbda2b2.jpg";